export default __webpack_public_path__ + "static/media/logo.2b8c6912.svg";